import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { Link, Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  formCommentLink,
  formCompleteJobsLink,
  formInboxItemLink,
  formInvestibleLink, formWizardLink,
  navigate,
  preventDefaultAndProp
} from '../../../utils/marketIdPathFunctions';
import clsx from 'clsx';
import { countByType } from './InvestiblesByPerson'
import { usePlanFormStyles } from '../../../components/AgilePlan'
import {
  getGroupPresences,
  getMarketPresences, isAutonomousGroup,
} from '../../../contexts/MarketPresencesContext/marketPresencesHelper';
import { MarketPresencesContext } from '../../../contexts/MarketPresencesContext/MarketPresencesContext';
import Chip from '@material-ui/core/Chip';
import { stageChangeInvestible } from '../../../api/investibles';
import { getInvestible, refreshInvestibles } from '../../../contexts/InvestibesContext/investiblesContextHelper';
import { InvestiblesContext } from '../../../contexts/InvestibesContext/InvestiblesContext';
import { DiffContext } from '../../../contexts/DiffContext/DiffContext';
import { getMarketInfo } from '../../../utils/userFunctions'
import {
  ISSUE_TYPE,
  QUESTION_TYPE,
  REPORT_TYPE,
  SUGGEST_CHANGE_TYPE,
  TODO_TYPE
} from '../../../constants/comments';
import { OperationInProgressContext } from '../../../contexts/OperationInProgressContext/OperationInProgressContext';
import {
  getFullStage,
  isBlockedStage,
  isRequiredInputStage
} from '../../../contexts/MarketStagesContext/marketStagesContextHelper';
import { MarketStagesContext } from '../../../contexts/MarketStagesContext/MarketStagesContext';
import { CommentsContext } from '../../../contexts/CommentsContext/CommentsContext';
import { SearchResultsContext } from '../../../contexts/SearchResultsContext/SearchResultsContext';
import { firstDisplayedOpenItem, SwimlaneOpenChip } from './swimlaneOpenChip';
import GravatarGroup from '../../../components/Avatars/GravatarGroup';
import { doRemoveEdit, doShowEdit } from './userUtils'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { getOptimisticInvestibleMove, onInvestibleStageChange } from '../../../utils/investibleFunctions';
import { useButtonColors } from '../../../components/Buttons/ButtonConstants'
import { outlinedChipStyle } from '../../../components/CustomChip/chipStyles'
import TintedIconBadge from '../../../components/CustomChip/TintedIconBadge'
import { getJobCardCode, getTicketNumber, stripHTML } from '../../../utils/stringFunctions';
import { Schedule } from '@material-ui/icons';
import { NotificationsContext } from '../../../contexts/NotificationsContext/NotificationsContext';
import {
  findMessageOfType,
  findMessageOfTypeAndId,
  findMessagesForInvestibleId
} from '../../../utils/messageUtils';
import { useSyncedMessages } from '../../../contexts/SyncedMessagesContext/SyncedMessagesContext';
import { IN_PROGRESS_WIZARD_TYPE, JOB_STAGE_WIZARD_TYPE } from '../../../constants/markets';
import UsefulRelativeTime from '../../../components/TextFields/UseRelativeTime';
import { isInPast } from '../../../utils/timerUtils';
import { GroupMembersContext } from '../../../contexts/GroupMembersContext/GroupMembersContext';
import { dehighlightMessage, isInInbox } from '../../../contexts/NotificationsContext/notificationsContextHelper';
import BugListItem from '../../../components/Comments/BugListItem';
import { MarketGroupsContext } from '../../../contexts/MarketGroupsContext/MarketGroupsContext';
import { getGroup } from '../../../contexts/MarketGroupsContext/marketGroupsContextHelper';
import { useCollaborators } from '../../Investible/Planning/PlanningInvestible';
import PlanningJobMenu from './PlanningJobMenu';
import { getInvestibleComments } from '../../../contexts/CommentsContext/commentsContextHelper';
import { calculateInvestibleVoters } from '../../../utils/votingUtils';
import { MarketsContext } from '../../../contexts/MarketsContext/MarketsContext';
import DismissableText from '../../../components/Notifications/DismissableText';
import { BLUE_LEVEL } from '../../../constants/notifications';
import useDoableStageGuard from '../../../components/AddNewWizards/JobStage/useDoableStageGuard';

// Orange palette for the swimlane overdue/report-required clock badge, matching
// the assistance-section Suggestion badge so the two views read the same
// (C-all-990 / Q-all-136, option O-1).
const CLOCK_PALETTE = { base: '#F29100', icon: '#B96F00', baseDark: '#F29100', iconDark: '#f3ad4d' };

export const usePlanningIdStyles = makeStyles(
  theme => {
    return {
      stages: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 0,
        '& > *': {
          borderRight: `1px solid ${theme.palette.primary.dark}`,
          flex: '1 1 25%',
          minWidth: '15ch',
          padding: theme.spacing(1),
          '&:last-child': {
            borderRight: 'none'
          }
        }
      },
      stageLabel: {},
      containerEmpty: {},
      containerDroppable: {
        backgroundColor: theme.palette.type === 'light' ? '#efefef' : 'grey'
      }
    };
  },
  { name: 'PlanningIdea' }
);

function PlanningIdeas(props) {
  const {
    myInvestiblesStageHash,
    marketId,
    acceptedStage,
    inDialogStageId,
    inReviewStageId,
    presenceId,
    groupId,
    comments = []
  } = props;
  const confirmDoableQuestions = useDoableStageGuard(marketId);
  const history = useHistory();
  const intl = useIntl();
  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down('sm'));
  const acceptedStageId = acceptedStage.id;
  const classes = usePlanningIdStyles();
  const [marketPresencesState, marketPresencesDispatch] = useContext(MarketPresencesContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [invState, invDispatch] = useContext(InvestiblesContext);
  const [operationRunning, setOperationRunning] = useContext(OperationInProgressContext);
  const [commentsState, commentsDispatch] = useContext(CommentsContext);
  const [, diffDispatch] = useContext(DiffContext);
  const [groupPresencesState] = useContext(GroupMembersContext);
  const [groupState] = useContext(MarketGroupsContext);
  const marketPresences = getMarketPresences(marketPresencesState, marketId);
  const groupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId, groupId);
  const group = getGroup(groupState, marketId, groupId);
  const isAutonomous = isAutonomousGroup(groupPresences, group);
  const myPresence = (marketPresences || []).find((presence) => presence.current_user) || {};
  // Id of the card just dropped into this row, so it can play a brief settle-in animation (J-all-322).
  const [recentlyMovedId, setRecentlyMovedIdState] = useState(undefined);
  function flagRecentlyMoved(investibleId) {
    setRecentlyMovedIdState(investibleId);
    setTimeout(() => setRecentlyMovedIdState((current) => (current === investibleId ? undefined : current)), 600);
  }

  function isBlockedByTodo(investibleId, currentStageId, targetStageId) {
    const investibleComments = comments.filter((comment) => comment.investible_id === investibleId) || [];
    const todoComments = investibleComments.filter(
      comment => comment.comment_type === TODO_TYPE && !comment.resolved
    );
    return targetStageId === inReviewStageId && !_.isEmpty(todoComments);
  }

  function stageChange(event, targetStageId) {
    event.preventDefault();
    const investibleId = event.dataTransfer.getData('text');
    const currentStageId = event.dataTransfer.getData('stageId');
    if (!operationRunning && !isBlockedByTodo(investibleId, currentStageId, targetStageId)) {
      const moveInfo = {
        marketId,
        investibleId,
        stageInfo: {
          current_stage_id: currentStageId,
          stage_id: targetStageId,
        },
      };
      const investible = getInvestible(invState, investibleId);
      const marketInfo = getMarketInfo(investible, marketId);
      const { assigned } = marketInfo;
      const isAssignToOther = !assigned?.includes(presenceId);
      // When moving to a row can't end up on a different row but can be on multiple rows
      if (isAssignToOther) {
        moveInfo.stageInfo.assignments = [presenceId];
      } else {
        moveInfo.stageInfo.assignments = assigned;
      }
      if (currentStageId !== targetStageId || isAssignToOther) {
        // Optimistically drop the card into its new spot immediately and run the backend stage change in
        // parallel - no waiting on the API (J-all-322). flagRecentlyMoved plays the settle-in animation.
        const optimisticInvestible = getOptimisticInvestibleMove(investible, marketId, targetStageId,
          moveInfo.stageInfo.assignments);
        if (optimisticInvestible) {
          refreshInvestibles(invDispatch, diffDispatch, [optimisticInvestible]);
          flagRecentlyMoved(investibleId);
        }
        // Card already moved, but flag operationRunning so the Uclusion logo blinks to show the save is in
        // progress (T-all-2224 Q-all-165 option O-2). Write actions are blocked until it returns, but the
        // user can still navigate away - the promise is not tied to this component, so the stage change
        // (and its state reconciliation) completes regardless of navigation.
        setOperationRunning(true);
        return stageChangeInvestible(moveInfo)
          .then((inv) => {
            if (inv) {
              const fullStage = getFullStage(marketStagesState, marketId, currentStageId) || {};
              onInvestibleStageChange(targetStageId, inv, investibleId, marketId, commentsState, commentsDispatch,
                invDispatch, diffDispatch, marketStagesState, undefined, fullStage, marketPresencesDispatch);
            }
            return true;
          })
          .catch(() => {
            // Stage change failed - revert the optimistic move back to the captured original. The error
            // toast is already raised by stageChangeInvestible (J-all-322 Q-all-162 option O-1).
            if (optimisticInvestible) {
              refreshInvestibles(invDispatch, diffDispatch, [investible]);
            }
            return false;
          })
          .finally(() => setOperationRunning(false));
      }
    }
    return Promise.resolve(true);
  }

  function removeDroppableById() {
    [acceptedStageId, inDialogStageId, inReviewStageId].forEach((stageId) => {
      const dropSource = document.getElementById(`${stageId}_${presenceId}`);
      if (dropSource) {
        dropSource.classList.remove(classes.containerDroppable);
      }
    });
  }

  function onDropVoting (event) {
    const investibleId = event.dataTransfer.getData('text');
    if (!investibleId) return;
    removeDroppableById();
    const investibleComments = comments.filter((comment) => comment.investible_id === investibleId
      && !comment.resolved) || [];
    const blockingComments = investibleComments.filter(comment => comment.comment_type === ISSUE_TYPE);
    const assignedInputComments = investibleComments.filter(
      comment => (comment.comment_type === QUESTION_TYPE || comment.comment_type === SUGGEST_CHANGE_TYPE)
        && presenceId === comment.created_by
    );
    if (!_.isEmpty(blockingComments) || !_.isEmpty(assignedInputComments)) {
      // Need to close comment(s) to move here
      navigate(history,
        `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, investibleId)}&stageId=${inDialogStageId}&assignId=${presenceId}`);
    } else {
      return stageChange(event, inDialogStageId).then((success) => {
        if (!success) {
          return;
        }
        if (!isAutonomous) {
          // Prompt for approval
          navigate(history,
            `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, investibleId)}&stageId=${inDialogStageId}&isAssign=false`);
        } else {
          const investibleComments = getInvestibleComments(investibleId, marketId, commentsState);
          const tasksInProgress = investibleComments.find((comment) => !comment.resolved && !comment.deleted && 
                comment.comment_type === TODO_TYPE && comment.in_progress);
          if (!_.isEmpty(tasksInProgress)) {
            navigate(history, formWizardLink(IN_PROGRESS_WIZARD_TYPE, marketId, investibleId));
          }
        }
      });
    }
  }

  function onDropAccepted(event) {
    const id = event.dataTransfer.getData('text');
    const stageId = event.dataTransfer.getData('stageId');
    if (myPresence.id !== presenceId) {
      if (stageId !== inDialogStageId) {
        // If you try to drop into someone else's accepted just route to their voting instead
        onDropVoting(event);
      }
    } else {
      removeDroppableById();
      const marketInfo = getMarketInfo(getInvestible(invState, id), marketId);
      const assignId = marketInfo.assigned?.includes(presenceId) ? undefined : presenceId;
      if (confirmDoableQuestions(id, acceptedStageId, assignId)) {
        return;
      }
      const link = getDropDestination(acceptedStageId, id, stageId);
      if (link) {
        navigate(history, link);
      } else {
        return stageChange(event, acceptedStageId);
      }
    }
  }

  function onDropReview (event) {
    const id = event.dataTransfer.getData('text');
    const stageId = event.dataTransfer.getData('stageId');
    const link = getDropDestination(inReviewStageId, id, stageId);
    removeDroppableById();
    if (link) {
      navigate(history, link);
    } else {
      return stageChange(event, inReviewStageId);
    }
  }

  function getDropDestination(divId, id, stageId) {
    const investible = getInvestible(invState, id);
    const marketInfo = getMarketInfo(investible, marketId);
    const { assigned } = marketInfo;
    const fullCurrentStage = getFullStage(marketStagesState, marketId, stageId);
    // Before get to this choice am rerouting to in dialog stage when go to someone else's accepted stage
    let link = undefined;
    if (divId === inReviewStageId) {
      const isTodoBlocked = isBlockedByTodo(id, stageId, divId);
      if (isTodoBlocked || isBlockedStage(fullCurrentStage) || isRequiredInputStage(fullCurrentStage)) {
        if (isAutonomous || !_.isEmpty(assigned)) {
          // Go to change stage close comment step with divId destination
          link = `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, id)}&stageId=${divId}`;
        } else {
          link = `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, id)}&stageId=${divId}&assignId=${presenceId}`;
        }
      }
    } else if (isBlockedStage(fullCurrentStage) || isRequiredInputStage(fullCurrentStage)) {
      if (isAutonomous || !_.isEmpty(assigned)) {
        // Go to change stage close comment step with divId destination
        link = `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, id)}&stageId=${divId}`;
      } else {
        link = `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, id)}&stageId=${divId}&assignId=${presenceId}`;
      }
    }
    return link;
  }

  function onDragOverProcess(event) {
    event.dataTransfer.dropEffect = 'move';
    event.preventDefault();
  }

  function onDragEnterProcess(event) {
    if (!event.target.id || !event.target.id.endsWith(presenceId)) return;
    event.target.classList.add(classes.containerDroppable);
    event.preventDefault();
  }

  function removeDroppable(event) {
    event.target.classList.remove(classes.containerDroppable);
    event.preventDefault();
  }

  function onDragLeaveProcess(event) {
    if (!event.target.id || !event.target.id.endsWith(presenceId)) return;
    if (event.currentTarget.contains(event.relatedTarget)) return;
    removeDroppable(event);
  }

  const acceptedInvestibles = myInvestiblesStageHash[acceptedStageId] || [];

  return (
    <div className={mobileLayout ? undefined : classes.stages}>
      <div id={`${inDialogStageId}_${presenceId}`} onDrop={onDropVoting} onDragEnd={removeDroppable}
           onDragOver={onDragOverProcess} onDragEnter={onDragEnterProcess} onDragLeave={onDragLeaveProcess}
       >
        {mobileLayout && !_.isEmpty(myInvestiblesStageHash[inDialogStageId]) && (
          <div style={{ marginTop: '0.5rem', marginLeft: '0.5rem' }}>
            <b><FormattedMessage id="planningVotingStageLabel"/></b>
          </div>
        )}
        <VotingStage
          id={inDialogStageId}
          investibles={myInvestiblesStageHash[inDialogStageId] || []}
          marketId={marketId}
          groupId={groupId}
          presenceId={presenceId}
          marketPresences={marketPresences}
          comments={comments}
          myPresence={myPresence}
          isAutonomous={isAutonomous}
          viewGroupId={groupId}
          recentlyMovedId={recentlyMovedId}
        />
      </div>
      <div id={`${acceptedStageId}_${presenceId}`} onDrop={onDropAccepted} onDragEnd={removeDroppable}
           onDragOver={onDragOverProcess} onDragEnter={onDragEnterProcess} onDragLeave={onDragLeaveProcess}
       >
        {mobileLayout && !_.isEmpty(myInvestiblesStageHash[acceptedStageId]) && (
          <div style={{ marginTop: '0.5rem', marginLeft: '0.5rem' }}>
            <b><FormattedMessage id="planningAcceptedStageLabel"/></b>
          </div>
        )}
        <AcceptedStage
          id={acceptedStageId}
          investibles={acceptedInvestibles}
          marketId={marketId}
          presenceId={presenceId}
          myPresence={myPresence}
          marketPresences={marketPresences}
          comments={comments}
          isAutonomous={isAutonomous}
          viewGroupId={groupId}
          recentlyMovedId={recentlyMovedId}
        />
      </div>
      <div id={`${inReviewStageId}_${presenceId}`} onDrop={onDropReview}
           onDragEnd={removeDroppable} onDragOver={onDragOverProcess} onDragEnter={onDragEnterProcess}
           onDragLeave={onDragLeaveProcess}
           style={{ flex: '2 1 50%'}}
      >
        {mobileLayout && !_.isEmpty(myInvestiblesStageHash[inReviewStageId]) && (
          <div style={{marginTop: '0.5rem', marginLeft: '0.5rem'}}>
            <b><FormattedMessage id="planningReviewStageLabel" /></b>
          </div>
        )}
        <ReviewStage
          id={inReviewStageId}
          investibles={myInvestiblesStageHash[inReviewStageId] || []}
          marketId={marketId}
          myPresence={myPresence}
          presenceId={presenceId}
          comments={comments}
          marketPresences={marketPresences}
          isAutonomous={isAutonomous}
          viewGroupId={groupId}
          recentlyMovedId={recentlyMovedId}
        />
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(history, formCompleteJobsLink(marketId, groupId, presenceId));
          }}
          style={{ fontSize: '0.8rem', whiteSpace: 'nowrap', display: 'block', marginTop: '0.5rem' }}
        >
          {intl.formatMessage({ id: 'showAllComplete' })}
        </Link>
      </div>
    </div>
  );
}

PlanningIdeas.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.object),
  investibles: PropTypes.arrayOf(PropTypes.object),
  marketId: PropTypes.string.isRequired,
  acceptedStage: PropTypes.object.isRequired,
  inDialogStageId: PropTypes.string.isRequired,
  inReviewStageId: PropTypes.string.isRequired,
  inBlockingStageId: PropTypes.string.isRequired,
  presenceId: PropTypes.string.isRequired
};

function Stage(props) {
  const {
    comments,
    id,
    investibles,
    marketId,
    isReview,
    isVoting,
    showCompletion,
    marketPresences,
    presenceId,
    isAutonomous,
    viewGroupId,
    myPresence,
    recentlyMovedId
  } = props;
  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down('sm'));
  const sortedInvestibles = investibles.sort(function(a, b) {
    const aMarketInfo = getMarketInfo(a, marketId);
    const bMarketInfo = getMarketInfo(b, marketId);
    return new Date(bMarketInfo.updated_at) - new Date(aMarketInfo.updated_at);
  });

  function investibleOnDragStart (event) {
    // Show the whole card as the drag image (T-all-2221). The browser default isn't enough - the card
    // contains links, so the native fallback is a tiny name+URL ghost; snapshot the card element itself
    // instead. currentTarget is the draggable card even when the drag starts on a child, and we keep the
    // grab point under the cursor so it reads as lifting the card.
    const card = event.currentTarget;
    // Hide the hover-only pencil (edit) icon before snapshotting so it isn't baked into the drag image -
    // it only signals click-through and shouldn't ride along on the dragged card (C-all-1033).
    doRemoveEdit(card.id);
    const rect = card.getBoundingClientRect();
    event.dataTransfer.setDragImage(card, event.clientX - rect.left, event.clientY - rect.top);
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text', card.id);
    const dragged = sortedInvestibles.find((inv) => inv.investible.id === card.id);
    const draggedStageId = (getMarketInfo(dragged, marketId) || {}).stage;
    event.dataTransfer.setData('stageId', draggedStageId || id);
  }

  const investiblesMap = sortedInvestibles.map(inv => {
    const { investible } = inv;
    const marketInfo = getMarketInfo(inv, marketId) || {};
    const yourVote = myPresence.investments?.find((investment) => investment.investible_id === investible.id);
    // No quick add from your vote so have to check that as well
    const unaccepted = isVoting && marketInfo.assigned?.includes(presenceId) &&
      !marketInfo.accepted?.includes(presenceId) && (!marketInfo.assigned?.includes(myPresence.id) || _.isEmpty(yourVote));
    const numQuestionsSuggestions = countByType(investible, comments,
      [QUESTION_TYPE, SUGGEST_CHANGE_TYPE]);
    const numOpenTasks = countByType(investible, comments, [TODO_TYPE]);

    return (
      <React.Fragment key={`stageFrag${investible.id}`}>
        <StageInvestible
          marketPresences={marketPresences || []}
          comments={comments || []}
          investible={investible}
          marketId={marketId}
          marketInfo={marketInfo}
          isReview={isReview}
          isVoting={isVoting}
          numQuestionsSuggestions={numQuestionsSuggestions}
          numOpenTasks={numOpenTasks}
          unaccepted={unaccepted}
          showCompletion={showCompletion}
          mobileLayout={mobileLayout}
          isAutonomous={isAutonomous}
          viewGroupId={viewGroupId}
          investibleOnDragStart={investibleOnDragStart}
          isRecentlyMoved={recentlyMovedId === investible.id}
        />
      </React.Fragment>
    )});

  if (!isReview) {
    if (_.isEmpty(sortedInvestibles)) {
      return (
        <DismissableText textId={isVoting ? 'votingStageHelp' : 'acceptedStageHelp'} showIcon={false}
                             display={_.isEmpty(sortedInvestibles)}
                             text={<div>
                             <FormattedMessage id={isVoting ? 'planningVotingStageLabel' : 'planningAcceptedStageLabel'}/>
                           </div>}
        />
      );
    }
    return investiblesMap;
  }
  if (_.isEmpty(sortedInvestibles)) {
    return (
      <dl style={{marginLeft: '2rem', display: "flex", alignItems: 'center', paddingTop: '1rem'}}>
        <FormattedMessage id="planningReviewStageLabel"/>
      </dl>
    );
  }
  return (
    <div style={{display: 'flex', flexFlow: 'row wrap', gap: '0px 5px'}}>
      {investiblesMap}
    </div>
  );
}

Stage.propTypes = {
  id: PropTypes.string.isRequired,
  investibles: PropTypes.array.isRequired,
  marketId: PropTypes.string.isRequired
};

function VotingStage (props) {
  return (
    <Stage
      isVoting
      {...props}
    />
  );
}

function AcceptedStage (props) {
  return (
    <Stage
      showCompletion
      {...props}
    />
  );
}

function ReviewStage (props) {
  return (
    <Stage
      isReview
      {...props}
    />
  );
}

const generalStageStyles = makeStyles((theme) => {
  return {
    chipClass: {
      fontSize: 10,
      cursor: 'pointer'
    },
    chipStyleRed: {
      backgroundColor: '#E85757',
      color: 'white'
    },
    chipStyleGreen: {
      backgroundColor: 'white',
      border: '0.5px solid grey'
    },
    smallGravatar: {
      width: '24px',
      height: '24px',
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: '0.35rem',
      marginBottom: '0.35rem'
    },
    cardHeaderMetadata: {
      display: 'flex',
      alignItems: 'center',
      flex: '1 1 auto',
      // B-all-632: constrained cards wrap complete metadata units instead of
      // squeezing status text and pills into broken multi-line fragments.
      flexWrap: 'wrap',
      minWidth: 0,
      rowGap: '0.35rem',
      '& > *': {
        flexShrink: 0,
        whiteSpace: 'nowrap'
      }
    },
    cardHeaderCode: {
      display: 'flex',
      flexShrink: 1,
      fontSize: '.75rem',
      marginLeft: 'auto',
      maxWidth: '100%',
      minWidth: 0,
      paddingLeft: '0.5rem',
      paddingTop: '0.25rem',
      whiteSpace: 'nowrap'
    },
    outlinedAccepted: {
      border: `1px solid ${theme.palette.grey['400']}`,
      borderRadius: theme.spacing(1),
      fontSize: '.8em',
      cursor: 'grab',
      margin: theme.spacing(0.5, 0),
      padding: theme.spacing(1, 2),
      overflowWrap: 'break-word',
      overflowX: 'hidden'
    },
    // Brief settle-in when a card is optimistically dropped into its new column (J-all-322).
    '@keyframes settleIn': {
      '0%': { transform: 'scale(0.96)', opacity: 0.45 },
      '100%': { transform: 'scale(1)', opacity: 1 },
    },
    entering: {
      animation: '$settleIn 250ms ease-out',
    },
  };
});


function StageInvestible(props) {
  const {
    investible,
    marketId,
    marketInfo,
    showCompletion,
    comments,
    marketPresences,
    numQuestionsSuggestions,
    numOpenTasks,
    mobileLayout,
    unaccepted,
    isReview,
    isVoting,
    isAutonomous,
    viewGroupId,
    investibleOnDragStart,
    isRecentlyMoved
  } = props;
  const intl = useIntl();
  const theme = useTheme();
  const { countColor } = useButtonColors();
  const { completion_estimate: daysEstimate, assigned, group_id: groupId, stage: stageId,
    open_for_investment: openForInvestment } = marketInfo;
  const { id, name, labels } = investible;
  const history = useHistory();
  const to = `${formInvestibleLink(marketId, id)}#investible-header`;
  const [marketPresencesState] = useContext(MarketPresencesContext);
  const [messagesState, messagesDispatch] = useContext(NotificationsContext);
  // J-all-440: the card pill and its critical colour read the synced set only.
  const syncedMessages = useSyncedMessages();
  const [groupsState] = useContext(MarketGroupsContext);
  const [groupPresencesState] = useContext(GroupMembersContext);
  const [marketsState] = useContext(MarketsContext);
  const [investiblesState] = useContext(InvestiblesContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [commentsState] = useContext(CommentsContext);
  const [searchResults] = useContext(SearchResultsContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = generalStageStyles();
  const planClasses = usePlanFormStyles();
  const investors =calculateInvestibleVoters(id, marketId, marketsState, investiblesState,
    marketPresences, false, false)
  const investibleComments = comments.filter((comment) => comment.investible_id === id) || [];
  const collaboratorsForInvestible = useCollaborators(marketPresences, investibleComments, marketPresencesState,
    id, marketId, true);
  const hasDaysEstimate = showCompletion && daysEstimate && !isInPast(new Date(daysEstimate));
  const unreadEstimate = findMessageOfType('UNREAD_ESTIMATE', id, messagesState);
  function requiresStatusMessage(id) {
    const message = findMessageOfTypeAndId(id, messagesState, 'REPORT');
    if (!_.isEmpty(message)) {
      return message;
    }
    return findMessageOfType('REPORT_REQUIRED', id, messagesState);
  }
  const doesRequireStatusMessage = requiresStatusMessage(id);
  const labelsSorted = _.reverse(_.sortBy(labels, "updated_at"));
  const label = _.isEmpty(labelsSorted) ? undefined : labelsSorted[0].label;

  function getMessagesChip() {
    const messagesRaw = findMessagesForInvestibleId(id, syncedMessages);
    const messages = messagesRaw.filter((message) => isInInbox(message));
    const newMessages = messages.filter((message) => message.is_highlighted);
    // Just go to the first new message associated with this investible - do not show read messages
    const myMessage = newMessages[0];
    if (myMessage) {
      const isHighlighted = myMessage.is_highlighted;
      const myMessages = isHighlighted ? newMessages : messages;
      return (
        <Tooltip title={intl.formatMessage({ id: 'messagePresent' })}>
          {/* Outlined-red chip (C-all-990) - this "N new" pill had escaped the
             shared outlined-chip format and was still a solid fill. */}
          <span className={'MuiTabItem-tag'} style={{...outlinedChipStyle('red', theme.palette.type === 'dark'),
            cursor: 'pointer', marginRight: '0.5rem', borderRadius: 22, paddingLeft: '8px', paddingRight: '8px',
            paddingTop: '2px', paddingBottom: '2px', display: 'inline-flex', alignItems: 'center',
            fontSize: '0.75rem', lineHeight: 1.2}}
                onClick={(event) => {
                  preventDefaultAndProp(event);
                  // TODO same here 
                  dehighlightMessage(myMessage, messagesDispatch);
                  navigate(history, formInboxItemLink(myMessage));
                }}
                onMouseOver={(event) => {
                  preventDefaultAndProp(event);
                }}
          >
            {_.size(myMessages)} {intl.formatMessage({ id: isHighlighted ? 'new' : 'notifications' })}
          </span>
        </Tooltip>
      );
    }
    return undefined;
  }

  function getCountChip(labelNum, toolTipId, chipColor = 'orange', target) {
    return (
      <SwimlaneOpenChip labelNum={labelNum} toolTipId={toolTipId} chipColor={chipColor} target={target} />
    );
  }
  const recordPositionToggle = (event) => {
    if (anchorEl === null) {
      preventDefaultAndProp(event);
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(null);
    }
  };
  const isRequiredInputCard = isRequiredInputStage(getFullStage(marketStagesState, marketId, stageId) || {});
  const hasHighlightedNotifications = !_.isEmpty(
    findMessagesForInvestibleId(id, syncedMessages).filter((message) => isInInbox(message) && message.is_highlighted)
  );
  const openItemContext = {
    searchResults, investiblesState, marketPresencesState, commentsState, marketPresences,
  };
  const taskTarget = firstDisplayedOpenItem(comments, id, [TODO_TYPE], 'tasks', openItemContext);
  const assistanceTarget = firstDisplayedOpenItem(comments, id, [QUESTION_TYPE, SUGGEST_CHANGE_TYPE],
    'assistance', openItemContext);
  const countChip = mobileLayout ? undefined :
    getCountChip(isVoting ? numQuestionsSuggestions : numOpenTasks, isVoting ? 'inputRequiredCountExplanation':
      'openTasksCountExplanation', isRequiredInputCard && hasHighlightedNotifications ? 'red' : 'orange',
      isVoting ? assistanceTarget : taskTarget);
  // B-all-497: a non-assignee question or suggestion does not move a Reviewable job to Debatable,
  // so without its own chip and preview bars it was invisible in the swimlanes
  const assistanceChip = mobileLayout || !isReview ? undefined :
    getCountChip(numQuestionsSuggestions, 'inputRequiredCountExplanation', 'orange', assistanceTarget);
  const messagesChip = mobileLayout || (isRequiredInputCard && countChip) ? undefined : getMessagesChip();
  const isSameGroup = groupId === viewGroupId;
  const groupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId, groupId);
  const otherVoter = groupPresences.find((presence) => !assigned.includes(presence.id));
  const { qualifier: jobQualifier, number: jobNumber } =
    getJobCardCode(marketInfo.ticket_code, viewGroupId, marketId, groupsState);
  const ticketNumber = jobNumber ? undefined :
    getTicketNumber(groupId, marketId, groupsState, isAutonomous, isSameGroup);
  const inProgressComments = comments.filter((comment) => comment.investible_id === investible.id && !comment.deleted
    && !comment.resolved && (comment.in_progress || comment.comment_type === QUESTION_TYPE) && 
    (!comment.root_comment_id || comments.find((c) => c.id === comment.root_comment_id)?.resolved !== true));
  const reviewComments = comments.filter((comment) => comment.investible_id === investible.id && !comment.deleted
    && !comment.resolved && (comment.comment_type === REPORT_TYPE && comment.notification_type !== BLUE_LEVEL));
  const assistanceComments = comments.filter((comment) => comment.investible_id === investible.id && !comment.deleted
    && !comment.resolved && [QUESTION_TYPE, SUGGEST_CHANGE_TYPE].includes(comment.comment_type));
  const isDark = theme.palette.type === 'dark';
  return (
    <>
      {anchorEl && (
        <PlanningJobMenu anchorEl={anchorEl} recordPositionToggle={recordPositionToggle} stageId={stageId}
                         groupId={groupId} marketId={marketId} investibleId={investible.id} assigned={assigned}
                         openForInvestment={openForInvestment} marketPresences={marketPresences} />
      )}
      <div key={investible.id} id={investible.id} onDragStart={investibleOnDragStart} draggable
           className={clsx(classes.outlinedAccepted, isRecentlyMoved && classes.entering)}
           onContextMenu={recordPositionToggle}
           style={{minWidth: isReview ? '45%' : undefined,
            maxWidth: isReview ? 'calc(50% - 3px)' : undefined,
            flex: isReview ? '1 1 45%' : undefined, 
            backgroundColor: isReview ? (isDark ? '#3b5b5f' : '#F4FAFB' ) : (isVoting ? (isDark ? '#273c3f' : '#CCEBEE') : 
            (isDark ? '#314b4f' : '#E0F3F5'))}}
           onMouseOver={() => doShowEdit(investible.id)}
           onMouseOut={() => doRemoveEdit(investible.id)}
           onClick={event => {
             preventDefaultAndProp(event);
             navigate(history, `${formInvestibleLink(marketId, investible.id)}#investible-header`);
           }}
      >
        <div className={classes.cardHeader}>
          <div className={classes.cardHeaderMetadata}>
          {!unaccepted && (isVoting || isReview) &&
            !_.isEmpty(collaboratorsForInvestible.filter((collaborator) => !assigned?.includes(collaborator.id))) && (
              <div style={{marginRight: '0.5rem'}}>
                <GravatarGroup users={collaboratorsForInvestible} gravatarClassName={classes.smallGravatar} />
              </div>
            )}
          {!unaccepted && ((isVoting && (_.isEmpty(otherVoter) || isRequiredInputCard)) || isReview) && (
            <div style={{marginRight: '0.5rem'}}>
              <Typography style={{fontSize: '.75rem'}}>
                {isVoting ? <span style={{color: countColor}}>{isRequiredInputCard ? 'Unresponded' : 'Paused'}</span> : <span style={{color: 'green'}}>Complete</span>} <UsefulRelativeTime value={new Date(marketInfo.last_stage_change_date)}/>
              </Typography>
            </div>
          )}
          {!unaccepted && isVoting && !_.isEmpty(otherVoter) && !isRequiredInputCard && (
            <div style={{marginRight: '0.5rem'}}>
              <Typography style={{fontSize: '.85rem', color: countColor}}>
                {_.size(investors)} {intl.formatMessage({ id: 'approvalsLower' })}
              </Typography>
            </div>
          )}
          {unaccepted && (
            <Tooltip
              title={intl.formatMessage({ id: 'planningAcceptExplanation' })}
            >
              <div className={planClasses.daysEstimation} style={{wordWrap: 'normal', marginRight: '0.5rem'}}>
                <FormattedMessage id='planningUnacceptedLabel' />
              </div>
            </Tooltip>
          )}
          {messagesChip}
          {!_.isEmpty(doesRequireStatusMessage) && (
            <Tooltip title={intl.formatMessage({ id: 'reportRequired'})}>
            {/* Overdue / report-required clock as a tinted orange badge matching
               the assistance section; a red dot marks an unread inbox report
               (C-all-990 / Q-all-136, option O-1). */}
            <span style={{ marginRight: '0.5rem', display: 'inline-flex',
                   cursor: isInInbox(doesRequireStatusMessage) ? 'pointer' : undefined }} onClick={(event) => {
                   if (isInInbox(doesRequireStatusMessage)) {
                     preventDefaultAndProp(event);
                     dehighlightMessage(doesRequireStatusMessage, messagesDispatch);
                     navigate(history, formInboxItemLink(doesRequireStatusMessage));
                   }
                 }}
            >
              <TintedIconBadge icon={Schedule} palette={CLOCK_PALETTE}
                               unread={isInInbox(doesRequireStatusMessage)} />
            </span>
            </Tooltip>
          )}
          {countChip}
          {assistanceChip}
          {hasDaysEstimate && (
            <div style={{ whiteSpace: 'nowrap', color: unreadEstimate ? countColor: undefined,
              cursor: unreadEstimate ? 'pointer' : undefined, marginRight: '0.5rem' }}
                 onClick={(event) => {
                   if (unreadEstimate) {
                     preventDefaultAndProp(event);
                     dehighlightMessage(unreadEstimate, messagesDispatch);
                     navigate(history, formInboxItemLink(unreadEstimate));
                   }
                 }}
                 onMouseOver={(event) => {
                   if (unreadEstimate) {
                     preventDefaultAndProp(event);
                   }
                 }}
            >
              <FormattedMessage id='estimatedCompletionToday' /> <UsefulRelativeTime value={new Date(daysEstimate)}/>
            </div>
          )}
          {!countChip && showCompletion && (
            <div style={{marginRight: '0.5rem'}}>
              <Typography style={{fontSize: '.75rem'}}>
                Approved <UsefulRelativeTime value={new Date(marketInfo.last_stage_change_date)}/>
              </Typography>
            </div>
          )}
          {ticketNumber && (
            <div style={{whiteSpace: 'nowrap', fontSize: '.75rem', marginRight: '0.5rem', paddingTop: '1.5px'}}>
              {ticketNumber}
            </div>
          )}
          </div>
          {jobNumber && (
            <div className={classes.cardHeaderCode} style={{flexShrink: jobQualifier ? 1 : 0}}>
              {jobQualifier ? (
                <React.Fragment>
                  <span style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>{jobQualifier}</span>
                  <span style={{flexShrink: 0}}>-{jobNumber}</span>
                </React.Fragment>
              ) : jobNumber}
            </div>
          )}
        </div>
        <div id={`planningIdea${id}`} style={{display: 'flex', paddingBottom: '0.7rem', paddingTop: '0.7rem'}}>
          <StageLink
            href={to}
            id={id}
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
              navigate(history, to);
            }}
          >
            <Typography variant="subtitle2" style={isReview ? { overflowWrap: 'anywhere' } : undefined}>{name}</Typography>
            {!_.isEmpty(label) && (
              <div key={label} style={{paddingTop: '0.7rem', cursor: 'pointer'}} onClick={(event) => {
                preventDefaultAndProp(event);
                navigate(history, `${formInvestibleLink(marketId, investible.id)}#approve`);
              }}>
                <Chip size="small" label={label} className={classes.chipClass}
                      style={{maxWidth: '90%'}}/>
              </div>
            )}
          </StageLink>
          <div id={`showEdit0${id}`} style={{visibility: 'hidden', pointerEvents: 'none'}}>
            <EditOutlinedIcon style={{maxHeight: '1.25rem', marginTop: '-0.2rem'}} />
          </div>
        </div>
        {showCompletion && !_.isEmpty(inProgressComments) && (
          inProgressComments.map((comment) => {
            const { body, id: commentId, comment_type: commentType } = comment;
            return <BugListItem key={commentId} id={commentId} title={stripHTML(body)} useMinWidth={false} useMobileLayout smallFont
                                useSelect={false} toolTipId='inProgress' commentType={commentType}
                                link={formCommentLink(marketId, marketInfo.group_id, id, commentId)} />;
          })
        )}
        {isReview && !_.isEmpty(reviewComments) && (
          reviewComments.map((comment) => {
            const { body, id: commentId, comment_type: commentType } = comment;
            return <BugListItem key={commentId} id={commentId} title={stripHTML(body)} useMinWidth={false} useMobileLayout smallFont
                                useSelect={false} toolTipId='inReview' commentType={commentType}
                                link={formCommentLink(marketId, marketInfo.group_id, id, commentId)} />;
          })
        )}
        {isReview && !_.isEmpty(assistanceComments) && (
          assistanceComments.map((comment) => {
            const { body, id: commentId, comment_type: commentType } = comment;
            return <BugListItem key={commentId} id={commentId} title={stripHTML(body)} useMinWidth={false} useMobileLayout smallFont
                                useSelect={false} toolTipId='openAssistance' commentType={commentType}
                                link={formCommentLink(marketId, marketInfo.group_id, id, commentId)} />;
          })
        )}
      </div>
    </>
  );
}

const useStageLinkStyles = makeStyles(() => {
  return {
    root: {
      color: 'inherit',
      display: 'block',
      height: '100%',
      width: '95%'
    }
  };
});

function StageLink (props) {
  const { className, ...other } = props;
  const classes = useStageLinkStyles();
  return <Link className={clsx(classes.root, className)} style={{cursor: 'grab'}} {...other} />;
}

export default PlanningIdeas;
